import Group from './Group';

import './style.scss';

export default Group;



// WEBPACK FOOTER //
// ./src/components/Forms/RadioCheck/Group/index.js